import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompteComponent } from './compte/compte.component';
import { DetailCompteTabComponent } from './compte/detail-compte-tab/detail-compte-tab.component';
import { DossierComponent } from './dossier/dossier.component';
import { DetailDossierTabComponent } from './dossier/detail-dossier-tab/detail-dossier-tab.component';
import { DossierByGestionnaireComponent } from './dossier-by-gestionnaire/dossier-by-gestionnaire.component';
import { CompteByGestionnaireComponent } from './compte-by-gestionnaire/compte-by-gestionnaire.component';
import { HistoriqueImportationComponent } from './historique-importation/historique-importation.component';
import { ProvisionsComponent } from './provisions/provisions.component';
import { VuePortefeuilleComponent } from './vue-portefeuille/vue-portefeuille.component';


const routes: Routes = [
  {
    path: '',
    data: {breadcrumb: 'Suivi portefeuille'},
    children: [
        
      {
        path:'',
        redirectTo: 'comptes',
        pathMatch: 'full' 
      },
      {
        path: 'comptes',
        component: CompteComponent,
        data: {breadcrumb: 'Tous les comptes'},
      },
      {
        path: 'comptes-by-gestionnaire',
        component: CompteByGestionnaireComponent,
        data: {breadcrumb: 'tous les comptes par gestionnaire'},
      },
      {
        path: 'detail-compte/:codeClient', 
        data: {breadcrumb: 'détail compte'},
        component: DetailCompteTabComponent,
      },
      
      {
        path: 'dossiers',
        component: DossierComponent,
        data: {breadcrumb: 'Tous les dossiers'},
      },
      {
        path: 'dossiers-by-gestionnaire',
        component: DossierByGestionnaireComponent,
        data: {breadcrumb: 'tous les dossiers par gestionnaire'},
      },

      {
        path: 'detail-dossier/:numDossier', 
        data: {breadcrumb: 'détail dossier'},
        component: DetailDossierTabComponent,
      },
      {
        path: 'historique-importation',
        component: HistoriqueImportationComponent,
        data: {breadcrumb: 'Historique importation'},
      },
      {
        path: 'vue-portefeuille',
        component: VuePortefeuilleComponent,
        data: {breadcrumb: 'Vue portefeuille'},
      },
      {
        path: 'provisions',
        component: ProvisionsComponent,
        data: {breadcrumb: 'Provisions'},
      }

    ]
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuiviPortefeuilleRoutingModule { }
